/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface NewCommentDTO { 
    code?: string;
    description?: string;
    commentType?: NewCommentDTO.CommentTypeEnum;
}
export namespace NewCommentDTO {
    export type CommentTypeEnum = 0 | 1 | 2 | 3;
    export const CommentTypeEnum = {
        NUMBER_0: 0 as CommentTypeEnum,
        NUMBER_1: 1 as CommentTypeEnum,
        NUMBER_2: 2 as CommentTypeEnum,
        NUMBER_3: 3 as CommentTypeEnum
    };
}